const { Application } = Shopware;

Application.addServiceProviderDecorator('ruleConditionDataProviderService', (ruleConditionService) => {
    ruleConditionService.addCondition('netiOrderAmountHandlerCartAmount', {
        component: 'sw-condition-generic',
        label: 'global.sw-condition.condition.netiOrderAmountHandlerCartAmountRule',
        scopes: ['cart'],
        group: 'cart',
    });

    return ruleConditionService;
});
